import { FC } from 'react'
import styles from 'components/features/socialFeed/Compose/Compose.styl'
import { WithComposeId, PostUid, CommentUid } from 'interfaces/feed'
import { ComposeFocusable } from 'components/features/socialFeed/ComposeFocusable/ComposeFocusable'
import { ComposeAttach } from 'components/features/socialFeed/ComposeAttach/ComposeAttach'
import { ComposeExpanded } from 'components/features/socialFeed/ComposeExpanded/ComposeExpanded'
import { ComposeActions } from 'components/features/socialFeed/ComposeActions/ComposeActions'
import { ComposeInputController } from 'components/features/socialFeed/ComposeInputController/ComposeInputController'
import { ComposeMount } from 'components/features/socialFeed/ComposeMount/ComposeMount'
import { ComposeLayout } from 'components/features/socialFeed/ComposeLayout/ComposeLayout'
import { ComposeNextToInput } from 'components/features/socialFeed/ComposeNextToInput/ComposeNextToInput'
import cn from 'classnames'
import { useComposeState } from 'helpers/hookHelpers'

type ComposeProps =
  & WithComposeId
  & {
    isEdit?: boolean
    postUid?: PostUid
    commentUid?: CommentUid
    parentCommentUid?: CommentUid

    placeholder?: string
    focusOnMount?: boolean
    onDone?: () => void
  }

export const Compose: FC<ComposeProps> = (props) => {
  const {
    composeId,
    isEdit,
    postUid,
    commentUid,
    parentCommentUid,
    placeholder,
    focusOnMount,
    onDone,
  } = props

  const { id, type } = useComposeState(props.composeId, { id: null, type: null })

  const isComposeStateCreated = !!id

  return (
    <ComposeMount
      composeId={ composeId }
      isEdit={ isEdit }
      postUid={ postUid }
      commentUid={ commentUid }
      parentCommentUid={ parentCommentUid }
      placeholder={ placeholder }
      focusOnMount={ focusOnMount }
    >
      { isComposeStateCreated && (
        <div className={ cn(type === 'comment' && styles.comment) }>
          <ComposeFocusable composeId={ composeId }>
            <ComposeLayout composeId={ composeId }>
              <div className={ styles.input }>
                <ComposeInputController composeId={ composeId } />
              </div>
              <ComposeExpanded composeId={ composeId }>
                <div className={ styles.nextToInput }>
                  <ComposeNextToInput composeId={ composeId } />
                </div>
              </ComposeExpanded>
              <div className={ styles.attach }>
                <ComposeAttach composeId={ composeId } />
              </div>
              <ComposeExpanded composeId={ composeId }>
                <div className={ styles.commentActions }>
                  <ComposeActions
                    composeId={ composeId }
                    onCancel={ onDone }
                  />
                </div>
              </ComposeExpanded>
            </ComposeLayout>
          </ComposeFocusable>
        </div>
      )}
    </ComposeMount>
  )
}
